<template>
  <div :class="classes">
    <div class="my-auto">
      <h1 class="text-white font-bold text-2xl">Whoops!</h1>
      <h1 class="text-blue-300 font-bold text-lg">{{message}}</h1>
    </div>

    <div v-if='retry' class="grow flex flex-row justify-center">
      <pbc-button class="self-center text-center" @click='$emit("retry")' >
        <span class="p-2 align-center text-lg">Retry</span>
      </pbc-button>
    </div>
    <div v-else class="grow flex flex-row justify-center">
      <pbc-button class="self-center text-center" @click='$emit("close")' >
        <span class="p-2 align-center text-lg">OK</span>
      </pbc-button>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    pin:{
      type:Boolean,
      default:true
    },
    error:{
      type:String,
      default:'genericError'
    },
    retry:{
      type:Boolean,
      default: false
    },
    message:{
      type:String,
      default:'Please try again...'
    }
  },
  mounted() {
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'error',
      extra:{
        error:this.error,
        message:this.message
      }
    });
  },
  computed: {
    classes() {
      if (this.pin) {
        return 'flex flex-row justify-between mx-4 fixed bottom-0 left-0 right-0 h-32 pbc-z-level-2 px-8 py-4 bg-gray-700 rounded-lg shadow mb-10 border border-blue-800';
      } else {
        return 'flex flex-row justify-between mx-4 px-8 py-4 bg-gray-700 rounded-lg border border-blue-800 shadow';
      }
    }
  }
}
</script>
